// athlete-sticky-cta.js — Phase 3 implementation per athlete_hub_implementation_spec.md Section 4.2.
//
// Toggles the .is-visible class on .athlete-sticky-cta when the user scrolls past
// #athlete-hero. Uses a RAF-throttled scroll listener instead of IntersectionObserver
// because IO was unreliable on initial page load at desktop breakpoint in the Horizon
// theme (only fired after a viewport resize, leaving the CTA stuck in offscreen state).
// Scroll listener re-measures geometry on every scroll/resize event — deterministic
// across browsers and viewport states.
//
// Performance: RAF throttle + passive listeners means at most one measurement per
// frame, no scroll jank.
//
// Click attribution: dispatches GA4 event (when gtag present) + a CustomEvent
// (`thrux:attribution_click`) for other listeners (Klaviyo profile sync etc.).

(function () {
  'use strict';

  function init() {
    const cta = document.querySelector('.athlete-sticky-cta');
    const hero = document.getElementById('athlete-hero');
    if (!cta || !hero) return;

    let ticking = false;

    function measure() {
      const rect = hero.getBoundingClientRect();
      // CTA appears once the bottom of the hero is at or above 50% of viewport height
      // (i.e., hero has scrolled up by more than half its height). Symmetric with the
      // original IntersectionObserver threshold (0.5).
      const heroBottomAboveMidline = rect.bottom <= window.innerHeight * 0.5;
      const offer = document.getElementById('athlete-offer');
      const order = offer?.querySelector('.athlete-offer__order');
      const footer = document.querySelector('footer');
      const orderRect = order?.getBoundingClientRect();
      const footerRect = offer && footer?.getBoundingClientRect();
      const buyingInView = orderRect && orderRect.top < window.innerHeight && orderRect.bottom > 0;
      const footerInView = footerRect && footerRect.top < window.innerHeight;
      if (heroBottomAboveMidline && !buyingInView && !footerInView) {
        cta.classList.add('is-visible');
      } else {
        cta.classList.remove('is-visible');
      }
      ticking = false;
    }

    function onScrollOrResize() {
      if (!ticking) {
        requestAnimationFrame(measure);
        ticking = true;
      }
    }

    // Initial measurement (covers SSR-hydrated state and direct loads on a scrolled URL)
    measure();

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    window.addEventListener('orientationchange', onScrollOrResize, { passive: true });

    // Click attribution capture. Phase 8 will extend with real GA4 wiring.
    cta.addEventListener('click', () => {
      const slug = cta.dataset.attribution || '';
      const launchState = cta.dataset.launchState || 'pre_launch';

      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.gtag === 'function') {
        window.gtag('event', 'attribution_click', {
          athlete: slug,
          cta_location: 'sticky',
          launch_state: launchState,
        });
      }

      window.dispatchEvent(
        new CustomEvent('thrux:attribution_click', {
          detail: { athlete: slug, cta_location: 'sticky', launch_state: launchState },
        })
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
